import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class AppAction extends Base {
    
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? 0 : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
   
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/appaction/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                        checked:data.record.onlyManager
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleChange (event)  {
        this.setState({
            checked: event.target.checked
        });
      };
    
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/appaction/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            order:Number(this.state.data.record.order)
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.id !== 0 ? "ویرایش اطلاعات فعالیت" : "افزودن فعالیت جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                    <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">عنوان</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="18" className="form-control " type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">ترتیب</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="18" className="form-control " type="text" defaultValue={this.state.data.record.order} onChange={e => this.state.data.record.order = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                    </div>
                               
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}